import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";

@autoinject
export class ElectricalConductivityFormatValueConverter {

	constructor(private i18n: I18N) { }

	toView(value: number) {

		if (isNaN(value)) {
			return this.i18n.tr("offline");
		}
		return `${value.toFixed(1)} µS⋅cm⁻¹`;
	}
}